import { SurveysI } from '../interfaces/surveys.interface'
import { SurveysService } from '../services/surveys.service'
import {
    SurveyCreateVariantResponseT,
    SurveyGetSurveyResponseT,
    SurveyPayloadT,
    SurveysCreateResponseT,
    SurveysExcelResponseT,
    SurveysGetListResponseT,
    SurveyUpdatePayloadT,
    SurveyUpdateVariantResponseT,
    VariantPayloadT,
} from '../types/survey.types'

const surveysService = new SurveysService()

class Surveys implements SurveysI {
    getList(page: number): Promise<SurveysGetListResponseT> {
        return surveysService.getList(page)
    }

    deleteSurvey(survey_id: number): Promise<void> {
        return surveysService.deleteSurvey(survey_id)
    }

    deleteVariant(survey_id: number, variant_id: number): Promise<void> {
        return surveysService.deleteVariant(survey_id, variant_id)
    }

    createSurvey(payload: SurveyPayloadT): Promise<SurveysCreateResponseT> {
        return surveysService.createSurvey(payload)
    }

    updateSurvey(survey_id: number, payload: SurveyUpdatePayloadT): Promise<void> {
        return surveysService.updateSurvey(survey_id, payload)
    }

    getSurvey(survey_id: number): Promise<SurveyGetSurveyResponseT> {
        return surveysService.getSurvey(survey_id)
    }

    createVariant(
        survey_id: number,
        payload: VariantPayloadT
    ): Promise<SurveyCreateVariantResponseT> {
        return surveysService.createVariant(survey_id, payload)
    }

    updateVariant(
        survey_id: number,
        variant_id: number,
        payload: VariantPayloadT
    ): Promise<SurveyUpdateVariantResponseT> {
        return surveysService.updateVariant(survey_id, variant_id, payload)
    }

    exportExcel(): Promise<SurveysExcelResponseT> {
        return surveysService.exportExcel()
    }
}

export const surveys = new Surveys()
